<template>
	<information-card class="full-section-height" :sub-title="subTitle">
		<div slot="title">
			{{ title }}
		</div>
		<div slot="content">
			<choose-the-job-description
				v-if="currentStep === 1 || currentStep === 3 || currentStep === 4"
			></choose-the-job-description>
			<required-skills-tutorial-section
				v-if="currentStep === 2"
			></required-skills-tutorial-section>
		</div>
	</information-card>
</template>

<script>
import { mapState } from 'vuex';
import { pathOr } from 'ramda';
import InformationCard from '../shared/components/content/InformationCard';
import ChooseTheJobDescription from './components/first-step/components/choose-the-job-description';
import RequiredSkillsTutorialSection from './components/second-step/components/required-skills-tutorial-section';
import { THREE_SIXTY_EVALUATION_NAMESPACE } from './store/store.constant';
import { DESCRIPTION_TITLES } from './constants/labels.constant';

export default {
	name: 'three-sixty-evaluation-name-description',
	components: {
		RequiredSkillsTutorialSection,
		ChooseTheJobDescription,
		InformationCard,
	},
	computed: {
		...mapState(THREE_SIXTY_EVALUATION_NAMESPACE, {
			currentStep: pathOr([], ['evaluationFlow', 'currentStep']),
		}),
		subTitle() {
			return this.currentStep === 1 ? 'Descripción' : 'Instrucciones';
		},
		title() {
			return DESCRIPTION_TITLES[this.currentStep];
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/three-sixty-evaluation-description.vue